<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00032.installation.capteurs' | translate"
      [description]="'P00032.installation.capteurs.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P00032.installation.capteursCompte' | translate"
      [nameCustom]="'P00032.installation.capteursCompte.titre' | translate"
      [value]="actionStack!.getValue('snISondeRxInstalle') === 0 ? false : true"
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.Sense_Installation,
          'snISondeRxInstalle',
          $event ? 1 : 0,
          null
        )
      "
    ></app-switch-configuration>

    @if (actionStack!.getValue('snISondeRxInstalle') === 1) {
      <app-larged-link
        [name]="'P00032.modal.sonderx.button' | translate"
        [textBeforeArrow]="
          positionSondeRx !== undefined
            ? (P00032PositionType[positionSondeRx]?.label | translate)
            : '...'
        "
        (onPress)="openPositionSondeRxModal()"
      >
      </app-larged-link>
    }

    <app-label-description
      [description]="
        'P00032.installation.capteursCompte.description' | translate
      "
    ></app-label-description>

    <!-- Configuration Sonde pH -->
    <app-switch-configuration
      [title]="'P00032.installation.sondePH' | translate"
      [nameCustom]="'P00032.installation.sondePH.titre' | translate"
      [value]="actionStack!.getValue('snISondePhInstalle') === 0 ? false : true"
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.Sense_Installation,
          'snISondePhInstalle',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('snISondePhInstalle') === 1) {
      <app-larged-link
        [name]="'P00032.modal.sondeph.button' | translate"
        [textBeforeArrow]="
          positionSondePh !== undefined
            ? (P00032PositionType[positionSondePh]?.label | translate)
            : '...'
        "
        (onPress)="openPositionSondePhModal()"
      >
      </app-larged-link>
    }

    <app-label-description
      [description]="'P00032.installation.sondePH.description' | translate"
    ></app-label-description>

    <!-- Configuration Débit -->
    <app-switch-configuration
      [title]="'P00032.installation.debit' | translate"
      [nameCustom]="'P00032.installation.debit.titre' | translate"
      [value]="
        actionStack!.getValue('snIInstallationCapteurDebit') === 0
          ? false
          : true
      "
      (onPress)="
        actionStack!.editValue(
          P00039DataRxTxIndex.Sense_Installation,
          'snIInstallationCapteurDebit',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('snIInstallationCapteurDebit') === 1) {
      <app-larged-link
        [name]="'P00032.modal.positiondebit.button' | translate"
        [textBeforeArrow]="
          positionDebit !== undefined
            ? (P00032PositionType[positionDebit]?.label | translate)
            : '...'
        "
        (onPress)="openPositionDebitModal()"
      >
      </app-larged-link>
    }

    @if (actionStack!.getValue('snIInstallationCapteurDebit') === 1) {
      <app-label-configuration
        [titleListe]="'P00032.installation.inversion.titre' | translate"
        [value]="actionStack!.getValue('snISensContactSecDebit')"
        [liste]="P00032SensContactEnum"
        (onPress)="openSensDetectionModal($event)"
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="'P00032.installation.debit.description' | translate"
    ></app-label-description>

    <app-information-title
      [title]="'P00032.modal.positiontemperature.smalltitle' | translate"
    ></app-information-title>

    <app-larged-link
      [name]="'P00032.modal.positiontemperature.button' | translate"
      [textBeforeArrow]="
        positionCapteurTemperature !== undefined
          ? (P00032PositionType[positionCapteurTemperature]?.label | translate)
          : '...'
      "
      (onPress)="openPositionCapteurTemperatureModal()"
    >
    </app-larged-link>

    <app-label-description
      [description]="'P00032.modal.positiontemperature.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
